/*
  RPECK 21/04/2025 - Variant picker change URL
  --
  Added to give us the ability to change the URL to a different product if the colour option was changed
*/
(function() {
  // --- PART 1: GLOBAL HISTORY INTERCEPTOR ---
  // Overrides the native history methods to automatically drop 'variant' parameter before it hits the URL bar
  const cleanUrlString = (url) => {
    if (!url) return url;
    try {
      const parsedUrl = new URL(url, window.location.origin);
      if (parsedUrl.searchParams.has('variant')) {
        parsedUrl.searchParams.delete('variant');
        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      }
    } catch (e) {}
    return url;
  };

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function(state, title, url) {
    return originalPushState.apply(this, [state, title, cleanUrlString(url)]);
  };

  history.replaceState = function(state, title, url) {
    return originalReplaceState.apply(this, [state, title, cleanUrlString(url)]);
  };


  // --- PART 2: THE COMBINED LISTINGS REDIRECT ---
  document.addEventListener('variant:change', function(event) {
    const variantPicker = (event.target && event.target.closest('variant-picker')) || document.querySelector('variant-picker');
    if (!variantPicker) return;

    // GATHER DIRECT SELECTION DATA STRAIGHT FROM THE DOM (Bypasses stale first-click event payloads)
    const checkedInputs = Array.from(variantPicker.querySelectorAll('input[type="radio"]:checked'))
      .sort((a, b) => {
        const posA = parseInt(a.getAttribute('data-option-position') || 0);
        const posB = parseInt(b.getAttribute('data-option-position') || 0);
        return posA - posB;
      });

    const selectedOptionValueIds = checkedInputs
      .map(input => input.getAttribute('data-option-value-id') || input.dataset.optionValueId)
      .filter(Boolean);

    const variantScript = variantPicker.querySelector('script[data-variant]');
    if (variantScript && variantScript.textContent.trim() !== "" && selectedOptionValueIds.length > 0) {
      try {
        const jsonData = JSON.parse(variantScript.textContent);
        let targetRedirectUrl = jsonData.linkedProduct || jsonData.url || jsonData.link || jsonData.redirect;

        // Fallback check against event stream data object if present
        if (event.detail && event.detail.variant && event.detail.variant.linkedProduct) {
          if (event.detail.variant.linkedProduct !== "/products/" && event.detail.variant.linkedProduct !== "/products") {
            targetRedirectUrl = event.detail.variant.linkedProduct;
          }
        }

        // Execute redirect if we mapped a cross-linked combined listing product path
        if (targetRedirectUrl && targetRedirectUrl !== "/products/" && targetRedirectUrl !== "/products") {
          window.location.href = targetRedirectUrl;
          return;
        }
      } catch (e) {}
    }
  });

  window.addEventListener('pageshow', () => {
    const input = document.querySelector('input[data-option-position="1"]');

    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();

// RPECK 07/05/2025 - Tabs update function
// Used by the RPECK tabs blocks - these are loaded dynamically and the JS doesn't carry through
window.update_tabs = function(e) {
  
  // RPECK 07/05/2025 - Get the selector from the input
  // The input provides a data-selector value which we can use to apply the 'active' class
  let active_selector = e.dataset.selectors;

  // RPECK 07/05/2025 - Only proceed if the active_selector variable is present
  // Ensures we're able to allocate the active class to any of the items required
  if(active_selector) {

    document.querySelectorAll(`.tabbed-block ~ *:not(${active_selector})`).forEach(function(item){
      item.classList.remove('active');
    });
    
    document.querySelectorAll(`.tabbed-block ~ ${active_selector}`).forEach(function(item){
      item.classList.add('active');
    });

  }
  
}

// RPECK 07/05/2025 - Start by showing the page
document.addEventListener('tab_change', function(){

  // RPECK 07/05/2025 - Get the first tab
  let tab = document.querySelector('.rpeck-tabbed-content input:checked');

  // RPECK 07/05/2025 - Run the tab if it's present
  if(tab) window.update_tabs(tab);
  
});

// RPECK 06/01/2025 - Size Guide in Fit Tab
document.addEventListener('DOMContentLoaded', function(event){
  document.querySelector('a[href="#size-guide"]')?.addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector('button.sizeguide')?.click();
  });
});
